import { Expose } from "class-transformer";
import { IsNumber, IsString } from "class-validator";

export class Translation {
  @Expose()
  @IsNumber()
  cultureId!: number;
  @Expose()
  @IsString()
  name!: string;
}
